import React from 'react' 
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

const Category = ({slug, lang}) => {
    const [_] = useTranslation('global');
  return (
    <li>
     
    <NavLink to={`/${slug}/${lang}/panel/products/category`}>
      <p className="d-inline ">{_("panel.category")}</p>
    </NavLink>
  </li>
  )
}

export default Category
